export default {
  // Page title
  'page.title': '世界时钟',
  
  // Time zones and cities
  'timezone.utc': 'UTC',
  'timezone.local': '本地时间',
  'timezone.currentTime': '当前时间',
  'timezone.label': '时区',
  'timezone.title': '{{city}} 时区',
  'timezone.localClockOffset': '本地时钟偏移',
  'timezone.timeZone': '时区',
  'timezone.today': '今天',
  'timezone.hours': '小时',
  'timezone.standardTimeZone': '标准时区',
  'timezone.daylightSavingTimeZone': '夏令时时区',
  
  // City names (Chinese translations)
  'city.newYork': '纽约',
  'city.london': '伦敦',
  'city.paris': '巴黎',
  'city.tokyo': '东京',
  'city.sydney': '悉尼',
  'city.dubai': '迪拜',
  'city.singapore': '新加坡',
  'city.hongKong': '香港',
  'city.shanghai': '上海',
  'city.beijing': '北京',
  'city.mumbai': '孟买',
  'city.moscow': '莫斯科',
  'city.berlin': '柏林',
  'city.losAngeles': '洛杉矶',
  'city.chicago': '芝加哥',
  'city.toronto': '多伦多',
  'city.vancouver': '温哥华',
  'city.brasilia': '巴西利亚',
  'city.buenosAires': '布宜诺斯艾利斯',
  'city.cairo': '开罗',
  'city.istanbul': '伊斯坦布尔',
  
  // How to use
  'howto.title': '如何使用在线世界时钟',
  'howto.step1': '此世界时钟网站显示全球任意城市的当前时间和世界时间。查看时区、世界时间差异和国际时间，瞬间了解全球时间。',
  'howto.step2': '世界时钟主页显示您的本地时间以及主要城市的多个世界时钟。每个世界时区都显示精确时间、日期和时区偏移信息。',
  'howto.step3': '点击世界时钟列表中的任意城市名称可查看详细时区信息。每个世界时间页面提供该地区的全面时区数据和当前时间。',
  'howto.step4': '使用世界时钟搜索功能查找任意全球城市的时间。完美适用于查看世界时区、国际时间协调和全球时间管理需求。',
  
  // User reviews
  'reviews.title': '用户评价',
  'reviews.globalBusiness': '国际商务必备！轻松协调不同时区的会议时间，非常方便。',
  'reviews.travelBlogger': '旅行规划必备！随时知道目的地的当地时间，不再被时差困扰。',
  'reviews.remoteTeam': '远程团队协作的完美工具！轻松了解不同国家同事的工作时间。',
  'reviews.internationalFamily': '与海外家人保持联系的好帮手！随时知道最佳通话时间，不会打扰他们休息。',
  'reviews.managerZhang': '作为项目经理，这帮助我更有效地与全球客户安排会议。',
  
  // User names
  'user.globalBusiness': '国际商务',
  'user.travelBlogger': '旅行博主',
  'user.remoteTeam': '远程开发者',
  'user.internationalFamily': '跨国家庭',
  'user.managerZhang': '张经理',
  
  // Keywords
  'keywords.worldclock': '世界时钟 时区 国际时间 现在几点',
  'keywords.english': 'world clock time zones international time what time is it',
  'keywords.japanese': '世界時計 タイムゾーン 国際時間 今何時',
  'keywords.spanish': 'reloj mundial zonas horarias tiempo internacional qué hora',
  'keywords.german': 'Weltzeituhr Zeitzonen internationale Zeit wie spät',
  'keywords.french': 'horloge mondiale fuseaux horaires temps international quelle heure',
  'keywords.russian': 'мировые часы часовые пояса международное время который час',

  // Country related
  'countriesTime': '各国时间',
  'timeIn': '时间',
  'cities': '个城市',
  'available': '可查询',
  'citiesIn': '城市列表',
  'viewDetails': '查看详情',
  'countryNotFound': '未找到国家',
  'backToWorldClock': '返回世界时钟',
  'cityNotFound': '未找到城市',
  'popularCitiesIn': '热门城市',
  'currentTime': '当前时间',
};